import ProductCatalogBox from './ProductCatalogBox';

import { connect } from 'react-redux';

import { analyticsActions } from 'src/analytics/store';

interface IDispatchFromProps {
  fireProductClickEvent(data: any): void;
}

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  fireProductClickEvent: (data: any) =>
    dispatch(analyticsActions.categoriesProductClick(data))
});

export default connect(null, mapDispatchToProps)(ProductCatalogBox);
